module.exports = __webpack_public_path__ + "img/Hillcrest Hall, the Skirt Barn.1953db93.jpeg";